import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';

function PaureusCell({ value }) {
  return <InnerHTML tag="div" className="px-data" html={value} />;
}

PaureusCell.propTypes = {
  value: PropTypes.string.isRequired,
};

export default React.memo(PaureusCell);
